/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const TeamDetails = lazyLoad(
  () => import('./index'),
  module => module.TeamDetails,
);
